






































































































































































































import axios from "axios";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { email, minLength, maxLength } from "vuelidate/lib/validators";


export default Vue.extend({
	components: {
		
	},
	props: ["workerdata", "amluokitukset", "maat"],

	data() {
		return {
			commLangs: [] as {}[],
			queryaml: '' as string,
			querycountry: '' as string,
			suggestaml: false as boolean,
			filteredaml: [] as any[],
			myInfo: {} as any,
			filteredcountries: [] as any[],
			suggestcountry: false as boolean,
			debounce: null as any,
			submitError: '' as string|TranslateResult
		};
	},

	validations: {
		myInfo: {
			puhelin: {
				minLength: minLength(10),
				maxLength: maxLength(16)
			},
			sahkopostiosoite: {
				email
			},
			titteli: {
				maxLength: maxLength(150)
			},
			terveys: {
				maxLength: maxLength(1000)
			},
			postiosoite: {
				maxLength: maxLength(255)
			},
			postinumero: {
				maxLength: maxLength(15)
			},
			postitoimipaikka: {
				maxLength: maxLength(200)
			}
		}
	},

	computed: {
		selectables(): any {
			if (this.$props.workerdata.ammattiluokitukset) {
				let theselectables = this.$props.amluokitukset;
				if (this.$props.workerdata.ammattiluokitukset.length > 0) {
					theselectables = theselectables.filter(
						(x: any) => !this.$props.workerdata.ammattiluokitukset.includes(x.uid)
					);
				}
				return theselectables;
			} else return null;
		},
		cFilteredaml(): [] {
			return this.$data.filteredaml
		},
		selectableCountries(): any {
			if (this.$props.workerdata.maat) {
				let thecountries = this.$props.maat;
				if (this.$props.workerdata.maat.length > 0) {
					thecountries = thecountries.filter(
						(x: any) => !this.$props.workerdata.maat.includes(x.uid)
					);
				}
				return thecountries;
			} else return null;
		},
		cFilteredcountries(): [] {
			return this.$data.filteredcountries
		}
	},

	methods: {
		handleOk(bvModalEvt: any) {
			bvModalEvt.preventDefault();
			this.handleSubmit();
		},
		handleSubmit() {
			if (!this.$v.$invalid) {
				this.commLangs.forEach((lang: any) => {
					if (lang.value == this.myInfo.kieli) {
						this.myInfo.asiointikieli = {
							uid: lang.value,
							nimi: lang.text,
							organisaatioId: lang.orgId,
						};
					}
				});
				this.$emit("primarysubmit", this.myInfo);
				this.$nextTick(() => {
					this.$bvModal.hide("primary-info");
				});
			}
			else {
				this.submitError = this.$t('submit-error')
			}
		},
		hideModal() {
			this.$bvModal.hide("primary-info");
		},
		getLanguages() {
			axios.get("Itsepalvelu/commlanguages").then((resp) => {
				resp.data.forEach((l: any) => {
					let obj;
					switch (this.$store.state.lang) {
						case 'fi':
							obj = {
								text: l.nimi,
								value: l.uid,
								orgId: l.organisaatioId,
							};
							break;
						case 'en': 
							obj = {
								text: l.nimiEnglanti,
								value: l.uid,
								orgId: l.organisaatioId,
							};
							break;
						case 'se':
							obj = {
								text: l.nimiRuotsi,
								value: l.uid,
								orgId: l.organisaatioId,
							};
							break;
						default:
							obj = {
								text: l.nimi,
								value: l.uid,
								orgId: l.organisaatioId,
							};
							break;
					}
					if(obj.text) {
						this.commLangs.push(obj);
					}
				});
			});
		},
		pushVocationClass(voc: any) {
			//lisää ammattiluokitus jos sitä ei löydy
			if (
				!this.workerdata.ammattiluokitukset.find((aml: any) => aml.uid == voc.uid)
			) {
				this.workerdata.ammattiluokitukset.push(voc);
			}
		},
		removeVoc(voc: any) {
			this.workerdata.ammattiluokitukset = this.workerdata.ammattiluokitukset.filter(
				function (value: any) {
					return value.uid != voc.uid;
				}
			);
		},
		vocTranslate(voc: any) {
			switch (this.$store.state.lang) {
				case 'fi':
					return voc.nimi;
				case 'en': 
					return voc.nimiEnglanti ? voc.nimiEnglanti : voc.nimi as string
				case 'se':
					return voc.nimiRuotsi ? voc.nimiRuotsi : voc.nimi as string
				default:
					return voc.nimi as string
			}
		},
		removeCountry(c: any) {
			this.workerdata.kansalaisuudet = this.workerdata.kansalaisuudet.filter(
				function (value: any) {
					return value.uid != c.uid;
				}
			);
		},
		rValtio(country :any) :string {
			switch (this.$store.state.lang) {
				case 'fi':
					return country.valtio as string
				case 'en': 
					return country.valtioEnglanti ? country.valtioEnglanti : country.valtio as string
				case 'se':
					return country.valtioRuotsi ? country.valtioRuotsi : country.valtio as string
				default:
					return country.valtio as string
			}
		},
		isPicked(voc: any): boolean {
			return !this.workerdata.ammattiluokitukset.find(
				(aml: any) => aml.uid == voc.uid
			);
		},
		toggleaml() {
			if(this.queryaml.length > 0 && !this.suggestaml) {
				this.suggestaml = !this.suggestaml
				this.queryaml = ''
			}
			else if (this.queryaml.length > 0 && this.suggestaml) {
				this.queryaml = ''
				this.suggestaml = true
			}
			else {
				this.suggestaml = !this.suggestaml
			}
		},
		togglecountry() {
			if(this.querycountry.length > 0 && !this.suggestcountry) {
				this.suggestcountry = !this.suggestcountry
				this.querycountry = ''
			}
			else if (this.querycountry.length > 0 && this.suggestcountry) {
				this.querycountry = ''
				this.suggestcountry = true
			}
			else {
				this.suggestcountry = !this.suggestcountry
			}
		},
		filterAmlArray() {
			if (this.queryaml.length > 2) {
				
				switch (this.$store.state.lang) {
						case 'fi':
							this.filteredaml = this.amluokitukset.filter((aml: any) => aml.nimi.toLowerCase().includes(this.queryaml.toLowerCase()))
							break;
						case 'en':
							this.filteredaml = this.amluokitukset.filter((aml: any) => aml.nimiEnglanti.toLowerCase().includes(this.queryaml.toLowerCase()))
							break;
						default:
							this.filteredaml = this.amluokitukset.filter((aml: any) => aml.nimiRuotsi.toLowerCase().includes(this.queryaml.toLowerCase()))
							break;
					}
				this.suggestaml = true
				
			}
			else {
				this.filteredaml = this.amluokitukset
			}
		},
		filterCountryArray() {
			clearTimeout(this.debounce)
			this.debounce = setTimeout(() => {
				if (this.querycountry.length > 2) {
					switch (this.$store.state.lang) {
						case 'fi':
							this.filteredcountries = this.maat.filter((m: any) => m.valtio.toLowerCase().includes(this.querycountry.toLowerCase()))
							break;
						case 'en':
							this.filteredcountries = this.$props.maat.filter((x:any) => x.valtioEnglanti?.toLowerCase().includes(this.querycountry.toLowerCase()))
							break;
						default:
							this.filteredcountries = this.maat.filter((m: any) => m.valtio.toLowerCase().includes(this.querycountry.toLowerCase()))
							break;
					}
					this.suggestcountry = true
				}
				else {
					this.filteredcountries = this.maat
				}
			}, 600)
		},
		formStatus(validation:any) {
			return {
				error: validation.$error,
				dirty: validation.$dirty
			}
		}
	},
	mounted() {
		this.getLanguages();
		this.filteredaml = this.amluokitukset;
		this.filteredcountries = this.maat;
	},
	watch: {
		queryaml: {
			handler: async function handle() {
				this.filterAmlArray()
			}
		},
		querycountry: {
			handler: async function handle() {
				this.filterCountryArray()
			}
		},
		workerdata: {
			handler: async function handle(workerdata) {
				this.myInfo = workerdata
			}
		}
	}
});
